import React from 'react';
import Icon, {
	PieChartOutlined,
	LineChartOutlined,
	AreaChartOutlined,
	ToTopOutlined,
	ColumnWidthOutlined,
	RetweetOutlined,
	LikeOutlined
} from '@ant-design/icons';
import { LibertyMutualIconCustomColor } from '@/assets/icons/liberty-mutual-icon-custom-color';
import { BackCompressiveForceEstimationSVG } from '@/assets/icons/back-compressive-force-estimationSVG';
import type { IconConfig } from '../types';

const ICON_SIZE = '30px';

export const TOOL_CONFIGS: Record<string, IconConfig> = {
	rula: {
		label: 'RULA',
		createIcon: () => React.createElement(PieChartOutlined, { style: { fontSize: ICON_SIZE } })
	},
	reba: {
		label: 'REBA',
		createIcon: () => React.createElement(LineChartOutlined, { style: { fontSize: ICON_SIZE } })
	},
	angle_time: {
		label: 'Angle by time',
		createIcon: () => React.createElement(AreaChartOutlined, { style: { fontSize: ICON_SIZE } })
	},
	liberty_mutual: {
		label: 'Material handling',
		createIcon: () =>
			React.createElement(Icon, {
				component: LibertyMutualIconCustomColor,
				style: { fontSize: ICON_SIZE }
			})
	},
	niosh: {
		label: 'Manual lifting',
		createIcon: () => React.createElement(ToTopOutlined, { style: { fontSize: ICON_SIZE } })
	},
	kim_pp: {
		label: 'Push and pull',
		createIcon: () => React.createElement(ColumnWidthOutlined, { style: { fontSize: ICON_SIZE } })
	},
	strain_index: {
		label: 'Strain index',
		createIcon: () => React.createElement(RetweetOutlined, { style: { fontSize: ICON_SIZE } })
	},
	kim_mho: {
		label: 'Manual Handling',
		createIcon: () =>
			React.createElement(LikeOutlined, {
				style: { fontSize: ICON_SIZE, transform: 'rotate(270deg)' }
			})
	},
	back_compressive_force_estimation: {
		label: 'Back compressive force estimation',
		createIcon: () => React.createElement(BackCompressiveForceEstimationSVG)
	}
} as const;
